/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { People } from '../../core/_models'
import { formatDateTime } from '../../../../../utils/dayJs/format'

type Props = {

    people: People
}

const CreatedInCell: FC<Props> = ({ people }) => (

    <div className='d-flex flex-column'>
        <a href='#' className='text-gray-800 text-hover-danger mb-1'>
            {people.createdAt ? formatDateTime(people.createdAt.toString()) : 'N/A'}
        </a>
    </div>
)

export { CreatedInCell }
